import { render, staticRenderFns } from "./PlayArrow.vue?vue&type=template&id=044675c4&"
import script from "./PlayArrow.vue?vue&type=script&lang=ts&"
export * from "./PlayArrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports